export default {
  methods: {
    urlToPartner () {
      if (this.$route.query.us === 'true' && this.$route.query.u !== undefined) {
        return `${process.env.VUE_APP_MARKET}/?locale=${this.lang_switips_link}&u=${this.$route.query.u}&us=${this.$route.query.us}`
      }
      if (this.$route.query.us === 'true' && this.$route.query.u === undefined) {
        return `${process.env.VUE_APP_MARKET}/?locale=${this.lang_switips_link}&us=${this.$route.query.us}`
      }
      if (this.$route.query.u) {
        return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}&u=${this.$route.query.u}&us=${this.$route.query.us}`
      }
      if (this.lang_switips === 'ru') {
        return `${process.env.VUE_APP_SWITIPS_DYNAMIC}/?locale=${this.lang_switips_link}#register`
      }
      if (this.lang_switips === 'uk' || this.lang_switips === 'kz') {
        return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}#register`
      }
      if (this.lang_switips === 'en' || this.lang_switips === 'es') {
        return `${process.env.VUE_APP_MYSWITPLANET}/?locale=${this.lang_switips_link}#register`
      }
      return `${process.env.VUE_APP_SWITIPS}/?locale=${this.lang_switips_link}#register`
    }
  }
}
